import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VoicemailManagerComponent } from "@onsip/web/features/administrators/pbx-settings/voicemail-manager/voicemail-manager.component";
import { VoicemailManagerRoutingModule } from "@onsip/web/features/administrators/pbx-settings/voicemail-manager/voicemail-manager-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { PhoneNumberListModule } from "@onsip/web/features/shared/components/phoneNumberList/phone-number-list.module";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { SipAddressFieldModule } from "@onsip/web/features/shared/components/sipAddressField/sip-address-field.module";
import { ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { VoicemailManagerViewComponent } from "./voicemail-manager-view/voicemail-manager-view.component";
import { VoicemailManagerEditComponent } from "./voicemail-manager-edit/voicemail-manager-edit.component";
import { LoadingContainerComponent } from "@onsip/web/features/shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [
    VoicemailManagerComponent,
    VoicemailManagerViewComponent,
    VoicemailManagerEditComponent
  ],
  imports: [
    CommonModule,
    VoicemailManagerRoutingModule,
    TranslateModule,
    PhoneNumberListModule,
    ExtensionsListModule,
    SipAddressFieldModule,
    ReactiveFormsModule,
    PipesModule,
    MatButtonModule,
    RouterModule,
    LoadingContainerComponent
  ]
})
export class VoicemailManagerModule {}
